import { FC } from 'react';
import i18next from 'i18next';
import styled from 'styled-components';

const HeaderContainer = styled.section`
  padding: 60px 0;
  text-align: center;
`;

const HeaderTitle = styled.h1`
  font-weight: normal;
  font-size: 2.333rem;
  color: ${({ theme }) => theme.baseBlue.a10};
`;

const HeaderSubtitle = styled.h2`
  font-size: 1rem;
  line-height: 1.733rem;
  font-weight: 100;
  max-width: 553px;
  color: ${({ theme }) => theme.baseBlue.a6};
  margin: 0 auto;
`;

interface Props {
  t: i18next.TFunction;
  titleKey: string;
  subTitleKey: string;
}

const AddItemPageHeader: FC<Props> = ({ t, titleKey, subTitleKey }) => (
  <HeaderContainer>
    <HeaderTitle data-translation={titleKey}>{t(titleKey)}</HeaderTitle>
    <HeaderSubtitle data-translation={subTitleKey}>{t(subTitleKey)}</HeaderSubtitle>
  </HeaderContainer>
);

export default AddItemPageHeader;
